import { Container, Typography, Paper, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import {
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
  PARROT_CONNECT_PAY_TERMS,
} from '../../application/constants/legalDocuments';

/**
 * Legal documents index page
 * Route: /legal
 */
export const LegalIndex = () => {
  const documents = [
    {
      title: 'Términos y Condiciones',
      description: 'Reglas y condiciones de uso de la plataforma ParrotConnect POS',
      path: '/legal/terms',
      version: TERMS_AND_CONDITIONS.version,
    },
    {
      title: 'Términos y Condiciones - ParrotConnectPay',
      description: 'Reglas y condiciones de uso de la aplicación de pagos ParrotConnectPay',
      path: '/legal/terms-pay',
      version: PARROT_CONNECT_PAY_TERMS.version,
    },
    {
      title: 'Aviso de Privacidad',
      description: 'Información sobre el tratamiento de datos personales',
      path: '/legal/privacy',
      version: PRIVACY_POLICY.version,
    },
  ];

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography component="h1" gutterBottom variant="h4">
          Documentos Legales
        </Typography>

        <Typography color="text.secondary" sx={{ mb: 3 }} variant="body1">
          Consulta nuestros documentos legales y políticas de privacidad.
        </Typography>

        <List>
          {documents.map((doc) => (
            <ListItem disablePadding key={doc.path}>
              <ListItemButton component={Link} to={doc.path}>
                <ListItemText primary={`${doc.title} (v${doc.version})`} secondary={doc.description} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
};
